export const GET_CERT = 'course/get_cert';